var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2e85d7acbced9264ff6a1f5d03d8b2357e6bf90d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["war-and-peace@fictive-kin"]={id:"2e85d7acbced9264ff6a1f5d03d8b2357e6bf90d"};
      